import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

import Paths from '../constants/Paths';
import LoginContainer from '../containers/LoginContainer';
import CoreWrapperContainer from '../containers/CoreWrapperContainer';
import NotFound from './NotFound';

import 'react-datepicker/dist/react-datepicker.css';
import '../lib/custom-ui/styles.css';

import '../styles.module.scss';

const Root = ({ store, history }) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact path={Paths.LOGIN} component={LoginContainer} />
        <Route exact path={Paths.ROOT} component={CoreWrapperContainer} />
        <Route exact path={Paths.DASHBOARD} component={CoreWrapperContainer} />
        <Route exact path={Paths.BRANDS} component={CoreWrapperContainer} />
        <Route exact path={Paths.LIST_SITES} component={CoreWrapperContainer} />
        <Route exact path={Paths.LIST_MODELS} component={CoreWrapperContainer} />
        <Route exact path={Paths.LIST_PROTOCOLS} component={CoreWrapperContainer} />
        <Route exact path={Paths.LIST_CHANNELS} component={CoreWrapperContainer} />
        <Route exact path={Paths.LIST_ITEMS} component={CoreWrapperContainer} />
        <Route exact path={Paths.LIST_DEVICES} component={CoreWrapperContainer} />
        <Route exact path={Paths.LIST_ALERTS} component={CoreWrapperContainer} />
        <Route exact path={Paths.DIAGRAM} component={CoreWrapperContainer} />
        <Route exact path={Paths.CHARTS} component={CoreWrapperContainer} />
        <Route exact path={Paths.CHARTS_COMPARE} component={CoreWrapperContainer} />
        <Route exact path={Paths.REPORTS} component={CoreWrapperContainer} />
        <Route exact path={Paths.REPORT_DEVICE} component={CoreWrapperContainer} />
        <Route exact path={Paths.TRENDS} component={CoreWrapperContainer} />
        <Route exact path={Paths.SETTING_GENERAL} component={CoreWrapperContainer} />
        <Route exact path={Paths.SETTING_INVOICES} component={CoreWrapperContainer} />
        <Route exact path={Paths.SETTING_USER} component={CoreWrapperContainer} />
        <Route exact path={Paths.SETTING_PRICES} component={CoreWrapperContainer} />
        <Route exact path={Paths.SETTING_EMAILS} component={CoreWrapperContainer} />
        <Route exact path={Paths.SETTING_DASHBOARD} component={CoreWrapperContainer} />
        <Route exact path={Paths.SETTING_ALARM} component={CoreWrapperContainer} />
        <Route exact path={Paths.LIST_ALERTS_SETTING} component={CoreWrapperContainer} />
        <Route exact path={Paths.FACTORIES} component={CoreWrapperContainer} />
        <Route exact path={Paths.SITES} component={CoreWrapperContainer} />
        <Route exact path={Paths.DEVICES} component={CoreWrapperContainer} />
        <Route exact path={Paths.REBOOT_SYSTEM} component={CoreWrapperContainer} />
        <Route exact path={Paths.ARCHITECTURE} component={CoreWrapperContainer} />
        <Route path="*" component={NotFound} />
      </Switch>
    </ConnectedRouter>
  </Provider>
);

Root.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
};

export default Root;
